import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBrightnessHighComponent } from "./med-icon-brightness-high.component";

@NgModule({
  declarations: [
    MedIconBrightnessHighComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBrightnessHighComponent,
  ],
})
export class MedIconBrightnessHighModule { }
